import { render, staticRenderFns } from "./SimpleCardIcon.vue?vue&type=template&id=1f4eafd0&scoped=true&"
import script from "./SimpleCardIcon.vue?vue&type=script&lang=js&"
export * from "./SimpleCardIcon.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCardIcon.vue?vue&type=style&index=0&id=1f4eafd0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4eafd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VIcon})
